import { typeUtils } from '@festina-life/core'

import type { CreateParameterFormData } from './types'

export const validateKey =
  typeUtils.createValidator<NonNullable<CreateParameterFormData>>()
